import { ThemeModule } from '../../front/lib/ThemeModule';
import { createApp } from 'vue';
import NewsletterApp from './NewsletterApp.vue';
import { restRequestTheme } from '../../front/lib/rest-api';
export class Newsletter extends ThemeModule {
    async init() {
        let rootEl = this.getElementById('app');
        if (!Newsletter.enums) {
            await Newsletter.loadEnums();
        }
        const app = createApp(NewsletterApp, { newsletter: this });
        app.mount(rootEl);
    }
    get enums() {
        return Newsletter.enums;
    }
    static async loadEnums() {
        const resp = await restRequestTheme('GET', 'editnews/newsletter/optin/enum');
        this.enums = resp.payload;
    }
}
